import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=38e4a153&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=ts&"
export * from "./EmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=38e4a153&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4a153",
  null
  
)

export default component.exports